import { createFileRoute, type SearchSchemaInput } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import {
  sectionListParams,
  sectionListQueryOptions,
  sectionListSearchSchema,
  SectionsPage,
} from '@/features/content';

export const Route = createFileRoute('/_authed/_active/s/$storeId/content/sections/')({
  staticData: { tours: ['content.sections'] },
  // Typed as the raw input so links into the list (`<Link to=".../content/sections">`) need no search.
  validateSearch: (search: Record<string, unknown> & SearchSchemaInput) =>
    sectionListSearchSchema.parse(search),
  loaderDeps: ({ search }) => search,
  beforeLoad: ({ context }) => {
    requirePermission(context.me, 'content.read');
  },
  loader: async ({ context, params, deps, cause }) => {
    const prefetch = context.queryClient
      .query({
        ...sectionListQueryOptions(params.storeId, sectionListParams(deps)),
        staleTime: 'static',
      })
      .catch(() => undefined);
    // Filter, sort and page changes on the list must not wait for the fetch, or a second pick in
    // the filter would build on the stale URL. The page's own query shows the previous rows.
    if (cause !== 'stay') await prefetch;
  },
  component: SectionsPage,
});
